import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Input,
  Label,
  FormGroup,
  CustomInput,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";
import Select from "react-select";

import { Link, useHistory, Redirect } from "react-router-dom";
import { withRouter } from "react-router";
import CustomSelect from "../../../../helpers/ui/CustomSelect";

import apiResponse from "../../../../services/apiResponse";

import UpdateBloc from "./Blocs/UpdateBloc";

class IndexView extends Component {
  updateBloc = new UpdateBloc();

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {},
      employeeOptions: [],
      selectedEmployee: null,
      isLoadingOptEmployee: true,
      loading: true,
      loadingTitle: "Mengambil data...",
      loadingInfo: "Tunggu beberapa saat",
    };
  }

  reformatOptions = (raw, label, value) => {
    return raw.map(function (data) {
      var newObj = {};
      newObj["label"] = data["employee_nip"] + " - " + data[label];
      newObj["value"] = data[value];
      newObj["model"] = data;

      return newObj;
    });
  };

  submitData = async () => {
    await this.updateBloc.fetchUpdate(this.state.dataForm);
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        uuid: this.state.dataForm.presensi_exclude_absen_uuid,
        ...values,
      },
      confirm: true,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
          loadingTitle: "Mengirim data...",
          loadingInfo: "Tunggu beberapa saat",
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    const queryParams = new URLSearchParams(this.props.location.search);

    this.updateBloc.updateChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.updateBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        // case apiResponse.INITIAL:
        //   this.setState({
        //     loading: true,
        //   });
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)
            this.setState({
              dataForm: response,
              selectedEmployee: response.employee,
              loading: false,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.updateBloc.employeeChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)
            this.setState({
              employeeOptions: this.reformatOptions(
                response.result,
                "employee_full_name",
                "employee_uuid"
              ),
              isLoadingOptEmployee: false,
            });
            this.updateBloc.fetchDetail({ uuid: queryParams.get("uuid") });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.updateBloc.fetchEmployee();
  }

  componentWillUnmount() {
    this.updateBloc.updateChannel?.unsubscribe();
    this.updateBloc.detailChannel?.unsubscribe();
    this.updateBloc.employeeChannel?.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>Edit Exclude Absen Pegawai </CardTitle>
                  <CardSubtitle className="mb-3">
                    Setiap isian yang bertanda (
                    <span className="text-danger">*</span>) adalah wajib diisi.
                  </CardSubtitle>
                  <hr />
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    <Row className="mb-3">
                      <label
                        htmlFor="presensi_exclude_absen_employee_uuid"
                        className="col-md-3 col-form-label"
                      >
                        Pegawai <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <CustomSelect
                          name={`presensi_exclude_absen_employee_uuid`}
                          errorMessage="Pilih Pegawai"
                          options={this.state.employeeOptions}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Pegawai"
                          isLoading={this.state.isLoadingOptEmployee}
                          onChange={(v) =>
                            this.setState({
                              selectedEmployee: v.model,
                            })
                          }
                          defaultValue={
                            this.state.dataForm
                              ?.presensi_exclude_absen_employee_uuid
                          }
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        NIP
                      </label>
                      <Col md="3">
                        <AvField
                          placeholder=""
                          name="presensi_exclude_absen_employee_nip"
                          id="presensi_exclude_absen_employee_nip"
                          readonly="readonly"
                          type="text"
                          className="form-control"
                          value={this.state.selectedEmployee?.employee_nip}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Nama
                      </label>
                      <Col md="3">
                        <AvField
                          placeholder=""
                          name="presensi_exclude_absen_employee_nama"
                          id="presensi_exclude_absen_employee_nama"
                          readonly="readonly"
                          type="text"
                          className="form-control"
                          value={
                            this.state.selectedEmployee?.employee_full_name
                          }
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Pangkat/Golongan
                      </label>
                      <Col md="3">
                        <AvField
                          placeholder=""
                          name="employee_current_rank_group_room"
                          id="employee_current_rank_group_room"
                          readonly="readonly"
                          type="text"
                          className="form-control"
                          value={
                            this.state.selectedEmployee
                              ?.employee_current_rank_group_room
                          }
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Jabatan
                      </label>
                      <Col md="3">
                        <AvField
                          placeholder=""
                          name="employee_current_position_name"
                          id="employee_current_position_name"
                          readonly="readonly"
                          type="text"
                          className="form-control"
                          value={
                            this.state.selectedEmployee
                              ?.employee_current_position_name
                          }
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Unit Kerja
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder=""
                          name="employee_current_work_unit_name"
                          id="employee_current_work_unit_name"
                          readonly="readonly"
                          type="textarea"
                          className="form-control"
                          value={
                            this.state.selectedEmployee
                              ?.employee_current_work_unit_name
                          }
                        />
                      </Col>
                    </Row>

                    {/* <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <div className="form-check form-switch mb-3">
                                                    <AvCheckboxGroup name="checkboxExample" errorMessage="Agreement harus di centang">
                                                        <AvCheckbox label="Centang untuk mengaktifkan jam kerja ini dan menonaktifkan jam kerja yang sedang aktif" value="1" />
                                                    </AvCheckboxGroup>
                                                </div>
                                            </Col>
                                        </Row> */}

                    <Row className="mb-3">
                      <label
                        htmlFor="presensi_exclude_absen_start_date"
                        className="col-md-3 col-form-label"
                      >
                        Berlaku Dari <span className="text-danger">*</span>
                      </label>
                      <Col md="3">
                        <AvField
                          name={`presensi_exclude_absen_start_date`}
                          type="date"
                          errorMessage="Masukkan Berlaku Dari"
                          validate={{ required: { value: true } }}
                          value={
                            this.state.dataForm
                              .presensi_exclude_absen_start_date
                          }
                          placeholder="Berlaku Dari"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="presensi_exclude_absen_end_date"
                        className="col-md-3 col-form-label"
                      >
                        Berlaku Sampai
                      </label>
                      <Col md="3">
                        <AvField
                          name={`presensi_exclude_absen_end_date`}
                          type="date"
                          placeholder="Berlaku Sampai"
                          value={
                            this.state.dataForm.presensi_exclude_absen_end_date
                          }
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to="?">
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan Data
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle={this.state.loadingTitle}
          loadingInfo={this.state.loadingInfo}
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to="/master/exclude_absen.html?" />
        ) : null}
      </Fragment>
    );
  }
}

//export default IndexView
export default withRouter(IndexView);
